import { ConstructorType, IConstructor } from '@/interfaces/constructor.interfaces';

import {
  DEFAULT_CAR_CARD_IDS_MAP,
  DEFAULT_CAR_LIST_IDS_MAP,
  DEFAULT_CAR_TILE_IDS_MAP,
  DEFAULT_MODEL_LIST_IDS_MAP,
  GET_DEFAULT_CAR_CARD,
  GET_DEFAULT_CAR_LIST,
  GET_DEFAULT_MODEL_LIST,
} from './car';
import {
  DEFAULT_FILTERS_IDS_MAP,
  GET_DEFAULT_FILTERS,
  GET_DEFAULT_FILTERS_WITH_FEATURE_MODEL,
} from './filters';
import PAGES from './pages';

export const DEFAULT_CONSTRUCTOR_IDS_MAP = {
  CONSTRUCTOR_CARS_PAGE: 'cars-page',
  CONSTRUCTOR_CARS_HEADER: 'cars-header',
  CONSTRUCTOR_CARS_CATALOG: 'cars-catalog',
  CONSTRUCTOR_CAR_PAGE: 'car-page',
  CONSTRUCTOR_CAR_HEADER: 'car-header',
  CONSTRUCTOR_CAR_CARD: 'car-card',
  CONSTRUCTOR_CAR_FINANCE: 'car-finance',
  CONSTRUCTOR_CAR_DEALER_COMMENT: 'car-dealer-comment',
  CONSTRUCTOR_CAR_DEALER_MAP: 'car-dealer-map',
  CONSTRUCTOR_CAR_BENEFITS: 'car-benefits',
  CONSTRUCTOR_CAR_EQUIPMENT: 'car-equipment',
  CONSTRUCTOR_CAR_BOOKING_REQUEST: 'car-booking-request',
  CONSTRUCTOR_CAR_BENEFITS_FOOTNOTE: 'car-benefits-footnote',
  CONSTRUCTOR_MODELS_PAGE: 'models-page',
  ...DEFAULT_CAR_CARD_IDS_MAP,
  ...DEFAULT_CAR_TILE_IDS_MAP,
  ...DEFAULT_FILTERS_IDS_MAP,
  ...DEFAULT_CAR_LIST_IDS_MAP,
  ...DEFAULT_MODEL_LIST_IDS_MAP,
};

export const GET_DEFAULT_CONSTRUCTOR: () => IConstructor = () => {
  return {
    [PAGES.Cars]: {
      id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CARS_PAGE,
      items: [
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CARS_HEADER,
          order: 1,
          span: 24,
          type: ConstructorType.CarsHeader,
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CARS_CATALOG,
          order: 3,
          span: 24,
          type: ConstructorType.Catalog,
          items: [GET_DEFAULT_FILTERS(), GET_DEFAULT_CAR_LIST()],
        },
      ],
    },
    [PAGES.Models]: {
      id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_MODELS_PAGE,
      items: [
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CARS_HEADER,
          order: 1,
          span: 24,
          type: ConstructorType.CarsHeader,
          props: {
            showCounter: false,
            showSort: false,
          },
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CARS_CATALOG,
          order: 3,
          span: 24,
          type: ConstructorType.Catalog,
          items: [GET_DEFAULT_FILTERS_WITH_FEATURE_MODEL(), GET_DEFAULT_MODEL_LIST()],
        },
      ],
    },
    [PAGES.CarId]: {
      id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_PAGE,
      items: [
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_HEADER,
          order: 0,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#FFFFFF',
            },
          },
          type: ConstructorType.CarHeader,
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_CARD,
          order: 1,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#FFFFFF',
            },
          },
          items: [GET_DEFAULT_CAR_CARD()],
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_FINANCE,
          order: 3,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#F2F0F0',
            },
          },
          type: ConstructorType.Finance,
          fields: ['model', 'price'],
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_DEALER_COMMENT,
          order: 5,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#FFFFFF',
            },
          },
          type: ConstructorType.DealerComment,
          fields: ['description'],
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_DEALER_MAP,
          order: 7,
          span: 24,
          type: ConstructorType.DealerMap,
          fields: ['locations'],
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_BENEFITS,
          order: 9,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#F2F0F0',
            },
          },
          type: ConstructorType.Benefits,
          fields: ['benefits', 'maxBenefit', 'price', 'minPrice'],
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_EQUIPMENT,
          order: 11,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#FFFFFF',
            },
          },
          type: ConstructorType.Equipments,
          fields: ['options', 'specificationsValues'],
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_BOOKING_REQUEST,
          order: 15,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#F2F0F0',
            },
          },
          type: ConstructorType.BookingRequest,
          fields: ['vin'],
        },
        {
          id: DEFAULT_CONSTRUCTOR_IDS_MAP.CONSTRUCTOR_CAR_BENEFITS_FOOTNOTE,
          order: 21,
          span: 24,
          container: true,
          containerProps: {
            style: {
              backgroundColor: '#FFFFFF',
            },
          },
          type: ConstructorType.BenefitsFootnote,
          fields: ['benefits'],
        },
      ],
    },
  };
};
